import type { Position } from '@xleddyl/types'

export const MAP_MIN_ZOOM = 9.5
export const MAP_CENTER = [11.335584056135161, 46.4926996771608] as [number, number]
export const MAP_LIMIT = [
   [10.201112082898817, 46.09632012673242], // sw
   [12.578017663140628, 47.21886260129162], // ne
] as [Position, Position]
export const MAP_INITIAL_LIMIT = [
   [11.403046976615798, 46.5932956287767],
   [11.268121135650347, 46.391917310270514],
] as [Position, Position]
